







































































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from '@/shared/app.constants';
import LeftNavigationComponent from "../Workspace/Components/LeftNavigation.vue";
import GrantDocuments from './GrantAgreement/Documents.vue';
import FinancialReportingPeriod from './GrantAgreement/FinancialReportingPeriod.vue';
import TechnicalReportingPeriod from './GrantAgreement/TechReportingPeriod.vue';
import AgreementSign from './GrantAgreement/AgreementSign.vue';

import { GrantData } from "@/entities";

const namespace: string = "grant";

@Component ({
  components: {
      LeftNavigationComponent,
      GrantDocuments,
      FinancialReportingPeriod,
      TechnicalReportingPeriod,
      AgreementSign,
      GrantInformation: () => import('./GrantAgreement/GrantInformation.vue')
  }
})
export default class GrantAgreementComponent extends Vue {

    @State(namespace) grant!: GrantData;
    @Action("getGrant", { namespace }) getGrant: any;
    @Action("getGrantData", { namespace }) getGrantData: any;
    @Action("saveGrant", { namespace }) saveGrant: any;
    @Action("saveAll", { namespace }) saveAll: any;
    @Action("saveGrantData", { namespace }) saveGrantData: any;

    selectedKey: string = Object.keys(this.subSections.properties)[0];
    docTags: any = [];
    showSideBar = true;

    mounted() {
        this.$services.document.documentTagBySection(['GRANT AGREEMENT'])
        .then((data) => {
            this.docTags = data;
        })
    }
    
    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    /** Return grant agreement sub sections */
    get subSections() {
        return _app.grantAgreementSections;
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.selectedKey = key;
        window.location.hash = `#${this.selectedKey}`;
    }

    back() {
        var grantId = this.grant.selectedGrant.GrantId.toString();
        this.$router.push({
            name: "grantSummary",
            params: { grantId: grantId }
        });
    }

    updateStatus(item) {
        this.grant.selectedGrant.WorkflowStatusId = item.StepId;
        this.grant.selectedGrant.Comments = item.Comments;
        this.grant.selectedGrant.Subject = item.Subject;
        this.grant.selectedGrant.notify = item.notify;
        this.grant.selectedGrant.IsAgreementSigned = 1;
        this.saveAll({
            grant: this.grant.selectedGrant,
            data: this.grant.grantData,
            id: this.grant.selectedGrant.GrantId
        }).then(() => { 
            this.$router.push({
            name: "grantSummary",
            params: { grantId: this.grant.selectedGrant.GrantId.toString() }
        });        
        });
    }
    fileChanged(e)
    {
        this.save()
    }
    /** Save the grant data */
    save() {
        this.saveAll({
            grant: this.grant.selectedGrant,
            data: this.grant.grantData,
            id: this.grant.selectedGrant.GrantId
        }).then(() => {  
            this.getGrantData(this.grant.selectedGrant.GrantId);           
        });
    }  


    updateDate(val) {
        this.grant.selectedGrant.AgreementDate = val;        
    }
    updatePPO(val) {
        this.grant.selectedGrant.PrimaryProgramOfficerId = val;        
    }
    updateIsConfidential(val) {
        this.grant.selectedGrant.IsConfidential = val;        
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
      if(changedRoute && changedRoute.name === 'grantAgreement') {

        //this.selectedTopMenu =  this.application.selectedItem;
        if(this.$route.hash)
          this.selectedKey = this.$route.hash.substr(1);
        else
          window.location.hash = `#${this.selectedKey}`;
        
        if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.grantId !== previousRoute.params.grantId ) {
            const grantId = changedRoute.params.grantId;
            this.getGrant(grantId).then((resp) => {
                if(resp) {
                    this.getGrantData(grantId);
                }
            });
        }
      }
    }     
}
